<template>
  <div class="showing-intervals">

    <div class="mt-30 showing-single-interval" v-for="(interval, index) in showing.interval" v-bind:key="index">
      <div class="grid2col mb-10 interval-header">
        <p>
          Anmälda {{ interval.time }}<br>
          <span class="fs-14 opaque-60">{{ interval.freeSlots }} bokningsbara platser</span>
        </p>
        <p class="text-right all-caps fg-primary" @click="addNewCustomerToShowing(interval.number, showing.id)">Lägg
          till</p>
      </div>

      <template v-if="interval.activities">
        <ShowingActivity v-for="activity in interval.activities" v-bind:key="activity.activityShowing" :activity="activity" :showingId="showing.id"></ShowingActivity>
      </template>
    </div>
  </div>

</template>

<script>
import ShowingActivity from './ShowingActivity';
import customerForm from '../forms/visningar/customerForm';

export default {
  name: 'ShowingInterval',
  components: {ShowingActivity},
  props: {
    showing: {
      type: Object,
    },
  },
  methods: {
    addNewCustomerToShowing(intervalNumber, objectShowingId) {
      let showingInfo = {
        intervalNumber: intervalNumber,
        objectShowingId: objectShowingId,
      };
      this.$store.commit('showing/STORE_CURRENT_SHOWINGS_SLOT_INFO', showingInfo);
      this.$store.commit('STORE_ACTIVE_COMPONENT', customerForm);
      this.$root.modalOpen = true;
    },

  },
};
</script>

<style>

</style>
